import { useContext, useEffect, useState } from "react";
import styles from "../Assets/styles/Assets.module.css";
import config from "../../../config";
import { submitCaptcha } from "../../../Utils/captcha";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { UserData } from "../../../Context/DataContext";
import useWindowDimensions from "../../Footer/footer";
const base_url = config.base_url;

function TableContent({ cell, row, canResend, id, rowNumber, code }) {
  const { width } = useWindowDimensions();
  const isFrench = useContext(LanguageContext).language.label === "fr";
  const [resend, setResend] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [userData, setUserData] = useState(UserData());

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  let rewardValue = "-";

  let codeExists;

  if (cell.column.id === "email_address" && cell.value) {
    let emailFirstPart = cell?.value?.split("@")[0];
    emailFirstPart.length > 7 && (emailFirstPart = emailFirstPart.slice(0, 7));

    return (
      <td className={styles.td}>
        {`${emailFirstPart}@${cell?.value?.split("@")[1]}`}{" "}
      </td>
    );
  }
  if (cell.column.id === "user_status") {
    const couponExists = userData?.referralData?.ownedCoupons?.filter(
      (coupon) => coupon === code
    );
    if (couponExists?.length === 0) codeExists = false;
    else if (codeExists?.length > 1) codeExists = true;
  }

  if (cell.value === null || cell.value === undefined) {
    rewardValue = "-";

    return (
      <td
        className={styles.td}
        {...cell.getCellProps()}
        {...row.getToggleRowExpandedProps({
          title: undefined,
        })}
      >
        -
      </td>
    );
  }
  if (cell.column.id === "reward" && cell.value !== null) {
    // const currency = cell.value.split(" ")[1];

    if (isFrench) {
      rewardValue = cell.value.split(" ")[0] + " €";
    } else {
      rewardValue = " $" + cell.value.split(" ")[0];
    }
  }
  // TODO: un-comment when you want to enable the resending emails
  const resendEmail = async () => {
    const token = await submitCaptcha();

    await fetch(base_url + "user/referral/invite", {
      method: "POST",
      mode: "cors",
      body: `id=${id}&token=${token}&code=${code}`,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        setResend(true);
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (width > 980) {
    return (
      <td
        className={styles.td}
        {...cell.getCellProps()}
        {...row.getToggleRowExpandedProps({
          title: undefined,
        })}
        style={
          cell.value === "Subscribed" ||
          cell.value === "Your Subscription Got Extended!" ||
          cell.value === "Votre abonnement a été prolongé!" ||
          cell.value === "Inscrit"
            ? { color: "#419F23", textTransform: "capitalize" }
            : row.value === "Has Logged"
            ? { color: "#419F23", textTransform: "capitalize" }
            : cell.value === "inactive"
            ? { color: "#B20606", textTransform: "capitalize" }
            : cell.value === "active"
            ? { color: "#419F23", textTransform: "capitalize" }
            : cell.value === "pending"
            ? { color: "#4100AC", textTransform: "capitalize" }
            : cell.column.id === "code"
            ? {}
            : { textTransform: "capitalize" }
        }
      >
        {/* {cell.value === "Invited" ? cell.render("Cell") : cell.render("Cell")} */}
        {cell.value === "code" ? (
          <span>{dublicatedcontent.dublicatedText197}</span>
        ) : cell.value === "email" ? (
          <span>{dublicatedcontent.dublicatedText198}</span>
        ) : cell.value === "link" ? (
          <span>{dublicatedcontent.dublicatedText199}</span>
        ) : cell.column.id === "reward" ? (
          <span>{rewardValue}</span>
        ) : cell.column.Header === "Date" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>{rowNumber}.</span>
            <span>{cell.value}</span>
          </div>
        ) : (
          cell.render("Cell")
        )}
        {/* TODO: un-comment when you want to enable the resending emails */}
        {(cell.value === "Invited" || cell.value === "Invité") &&
          canResend &&
          codeExists && (
            <span>
              &nbsp; | &nbsp;
              <span
                onClick={(e) => {
                  resendEmail();
                }}
                className={resend ? styles.sent : styles.resend}
              >
                {websiteCurrentLang.label === "en"
                  ? resend
                    ? "Sent!"
                    : "Resend"
                  : null}
                {websiteCurrentLang.label === "fr"
                  ? resend
                    ? "Envoyé!"
                    : "Renvoyer"
                  : null}
              </span>
            </span>
          )}
        {(cell.value === "Invited" || cell.value === "Invité") &&
          canResend &&
          !codeExists && (
            <span>
              &nbsp; | &nbsp;
              <span style={{ color: "red" }}>
                {dublicatedcontent.dublicatedText235}{" "}
              </span>
            </span>
          )}
      </td>
    );
  } else if (
    cell.column.id !== "date" &&
    cell.column.id !== "email_address" &&
    cell.column.id !== "user_status"
  ) {
    return null;
  } else
    return (
      <td
        {...cell.getCellProps()}
        {...row.getToggleRowExpandedProps({
          title: undefined,
        })}
        className={styles.td}
        onClick={(e) => {}}
        style={
          cell.value === "Subscribed" ||
          cell.value === "Your Subscription Got Extended!" ||
          cell.value === "Votre abonnement a été prolongé!" ||
          cell.value === "Inscrit"
            ? { color: "#419F23", textTransform: "capitalize" }
            : {
                cursor: "pointer",
                textTransform: "capitalize",
                overflowWrap: "anywhere",
              }
        }
      >
        {cell.value === "code" ? (
          <span>Coupon Code</span>
        ) : cell.value === "email" ? (
          <span>Invited via Email</span>
        ) : cell.value === "link" ? (
          <span>Direct link</span>
        ) : cell.column.id === "rewardd" ? (
          <span>{rewardValue}</span>
        ) : cell.column.Header === "Date" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "max-content",
            }}
          >
            <span>{rowNumber}.</span>
            <span>{cell.value}</span>
          </div>
        ) : cell.column.id === "user_status" ? (
          <div>
            <span>{row.original.user_status}</span>&nbsp;
            {/* TODO: un-comment when you want to enable the resending emails */}
            {(row.original.user_status === "Invité" ||
              row.original.user_status === "Invited") &&
              canResend &&
              codeExists && (
                <span>
                  |&nbsp;
                  <span
                    onClick={(e) => {
                      // resendEmail();
                    }}
                    className={resend ? styles.sent : styles.resend}
                  >
                    {websiteCurrentLang.label === "en"
                      ? resend
                        ? "Sent!"
                        : "Resend"
                      : null}

                    {websiteCurrentLang.label === "fr"
                      ? resend
                        ? "Envoyé!"
                        : "Renvoyer"
                      : null}
                  </span>
                </span>
              )}
            {(row.original.user_status === "Invité" ||
              row.original.user_status === "Invited") &&
              canResend &&
              !codeExists && (
                <span>
                  |&nbsp;
                  <span>{dublicatedcontent.dublicatedText235} </span>
                </span>
              )}
            <span>&nbsp;|</span>
            &nbsp;
            <span>{row.original.reward_status}</span>
          </div>
        ) : (
          cell.render("Cell")
        )}

        {/* {canResend && cell.value === "Invited" && (
          <span>
            &nbsp; | &nbsp;
            <span
              onClick={(e) => {
                // setResend(true);
                resendEmail();
              }}
              className={resend ? styles.sent : styles.resend}
            >
              {resend ? "Sent!" : "Resend"}
            </span>
          </span>
        )} */}
      </td>
    );
}

export default TableContent;
